import {Injectable} from '@angular/core';
import {EmissionsRequest} from "@app-model/emissions-request";
import {Storage} from "@app-shared/enums/storage";
import {EmissionsResponse} from "@app-model/emmisions-response";
import {EventBusService} from "@app-services/event-bus.service";

@Injectable({
    providedIn: 'root'
})
export class EmissionsControllerService {

    emissionsPayload: EmissionsRequest = this.createEmptyPayload();

    constructor(private eventBusService: EventBusService) {
        this.eventBusService.selectedCompanyRefresh$.subscribe(() => this.clear());
    }

    private createEmptyPayload(): EmissionsRequest {
        return {
            accommodationEmission: {
                accommodations: [],
                notApplicable: false
            },
            energyEmission: {
                energyPurchaseds: [],
                notApplicable: false
            },
            fuelEmission: {
                fuels: [],
                notApplicable: false
            },
            materialEmission: {
                materials: [],
                notApplicable: false
            },
            transportEmission: {
                notApplicable: false,
                transports: []
            },
            solidWasteEmission: {
                notApplicable: false,
                solidWastes: []
            },
        };
    }

    saveEmissionsPayloadRequest(): void {
        sessionStorage
            .setItem(Storage.PROJECT_EMISSIONS_PAYLOAD, JSON.stringify(this.emissionsPayload));
    }

    getEmissionsPayloadRequest(): EmissionsRequest {
        return JSON.parse(sessionStorage
            .getItem(Storage.PROJECT_EMISSIONS_PAYLOAD));
    }

    saveEmissionsPayloadResponse(payload: EmissionsResponse): void {
        sessionStorage
            .setItem(Storage.PROJECT_EMISSIONS_RESPONSE, JSON.stringify(payload));
    }

    getEmissionsPayloadResponse(): EmissionsResponse {
        return JSON.parse(sessionStorage
            .getItem(Storage.PROJECT_EMISSIONS_RESPONSE));
    }

    clear(): void {
        this.emissionsPayload = this.createEmptyPayload();
        sessionStorage.removeItem(Storage.PROJECT_EMISSIONS_PAYLOAD);
        sessionStorage.removeItem(Storage.PROJECT_EMISSIONS_RESPONSE);
    }
}
